module.exports = __webpack_public_path__ + "static/media/mastercard.b63d437a.svg";